<template>
  <error-component v-bind="$attrs" v-slot="{touch, faulty}">
    <input
      type="text"
      class="inp"
      v-bind="$attrs"
      :value="value"
      :class="{faulty}"
      @input="$emit('input', $event.target.value)"
      @blur="touch"
    />
    <div v-if="info" class="text-xs text-secondary_text mb-4 px-3">
      {{info}}
    </div>
  </error-component>
</template>

<script>
import ErrorComponent from "@/components/ErrorComponent";

export default {
  props: {
    value: String,
    info: String
  },
  components: {
    ErrorComponent
  }
}
</script>

<style>

</style>